import React, { useEffect } from "react";
import ControlTower from "./ControlTower";
import "./App.css";
import { initIdentity } from "./auth/netlifyIdentity";

function App() {
  useEffect(() => {
    initIdentity();
  }, []);

  return (
    <div className="App">
      <ControlTower />
    </div>
  );
}

export default App;
